/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const QuestionType = {
    SingleChoice: 'SingleChoice',
    MultipleChoice: 'MultipleChoice'
} as const;
export type QuestionType = typeof QuestionType[keyof typeof QuestionType];


export function instanceOfQuestionType(value: any): boolean {
    for (const key in QuestionType) {
        if (Object.prototype.hasOwnProperty.call(QuestionType, key)) {
            if (QuestionType[key as keyof typeof QuestionType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function QuestionTypeFromJSON(json: any): QuestionType {
    return QuestionTypeFromJSONTyped(json, false);
}

export function QuestionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionType {
    return json as QuestionType;
}

export function QuestionTypeToJSON(value?: QuestionType | null): any {
    return value as any;
}

export function QuestionTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): QuestionType {
    return value as QuestionType;
}

